import { default as logo } from './logo.svg';

import cn from 'classnames';

import classes from './logo.module.scss';

type TLogo = {
  subLogo?: string;
};

export const Logo = ({ subLogo }: TLogo) => {
  return (
    <div className={classes.root}>
      <img src={logo} alt="Greenway Developer Platform" />
    </div>
  );
};
